import React from 'react';
import '../../styles/SkeletonLoader.css';

interface SkeletonLoaderProps {
  height?: number;
  lines?: number;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ height = 160, lines = 4 }) => {
  return (
    <div
      className="glass-card skeleton-loader__root"
      style={{ height }}
    >
      <div
        className="skeleton skeleton-text skeleton-loader__title"
      />
      {Array.from({ length: lines }).map((_, i) => (
        <div
          key={i}
          className="skeleton skeleton-text skeleton-loader__line"
          style={{
            width: `${90 - i * 12}%`,
          }}
        />
      ))}
      <div
        className="skeleton skeleton-rect skeleton-loader__rect"
        style={{ height: height - 100 }}
      />
    </div>
  );
};

export default React.memo(SkeletonLoader);
